import { createFileRoute, redirect } from '@tanstack/react-router';

import { tokenStore } from '../shared/api/token-store';
import { SignInPage } from '../pages/auth';

export const Route = createFileRoute('/sign-in')({
  validateSearch: (search: Record<string, unknown>): { next?: string; reason?: 'signed-out' } => ({
    next: typeof search.next === 'string' ? search.next : undefined,
    reason: search.reason === 'signed-out' ? 'signed-out' : undefined,
  }),
  beforeLoad: ({ search }) => {
    if (tokenStore.access() ?? tokenStore.refresh()) {
      throw redirect({ to: search.next ?? '/flows' });
    }
  },
  component: () => {
    const { next, reason } = Route.useSearch();
    return <SignInPage next={next} signedOut={reason === 'signed-out'} />;
  },
});
